import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';
import { getDomRemovalDiagnostic } from './domRemovalDiagnostics';

type NextErrorBoundary = 'app' | 'locale' | 'global';

type NextBoundaryError = Error & { digest?: string };

const componentStackByBoundary = {
  app: 'Next app error boundary',
  locale: 'Next locale error boundary',
  global: 'Next global error boundary',
} as const;

export function logNextErrorBoundary(error: NextBoundaryError, boundary: NextErrorBoundary) {
  const additionalContext: Record<string, unknown> = { boundary: `next-${boundary}` };

  if (error.digest) {
    additionalContext.digest = error.digest;
  }

  const domRemoval = getDomRemovalDiagnostic(error);
  if (domRemoval) {
    additionalContext.domRemoval = domRemoval;
  }

  RpErrorBoundary.logError(error, { componentStack: componentStackByBoundary[boundary] }, additionalContext);
}
